import { BaseEntity } from '../../models';
import { motivoPerdaVendaSituacaoAtivo } from './situacao';
import { MotivoPerdaVendaExibicao } from './exibicao';
import { MotivoPerdaVendaPLM } from './plm';
import { MotivoPerdaVendaOportunidade } from './oportunidade/motivo-perda-venda-oportunidade';
import { MotivoPerdaVendaConcorrente } from './concorrente/motivo-perda-venda-concorrente';

export class MotivoPerdaVenda implements BaseEntity, MotivoPerdaVendaExibicao, MotivoPerdaVendaPLM, MotivoPerdaVendaOportunidade, MotivoPerdaVendaConcorrente {
    readonly id: number;
    idEmpresa: number;
    situacao: number;
    nome: string;

    // Flags de exibição
    perdaVenda: boolean;
    clienteCongelado: boolean;
    contatoCliente: boolean;
    revisaoPedidoOrcamento: boolean;

    // Flags de elegibilidade nas decisões de gate do PLM
    avancoComRessalvasPLM: boolean;
    permanenciaPLM: boolean;
    revitalizacaoPLM: boolean;
    reposicionamentoPLM: boolean;
    encerramentoPLM: boolean;

    causaPerdaOportunidade: boolean;

    inativacaoConcorrente: boolean;

    reaberturaMarketShare: boolean;

    constructor() {
        this.situacao = motivoPerdaVendaSituacaoAtivo.id;
        this.avancoComRessalvasPLM = false;
        this.permanenciaPLM = false;
        this.revitalizacaoPLM = false;
        this.reposicionamentoPLM = false;
        this.encerramentoPLM = false;
        this.causaPerdaOportunidade = false;
        this.inativacaoConcorrente = false;
        this.reaberturaMarketShare = false;
    }
}
